export function sortRowsOnKeyValue(series) {
  return series.map(serie => {
    serie.data.rows = _.sortBy(serie.data.rows, 'key');
    return serie;
  });
}

export function addMissingRowsToSeries(series) {
  let globalCategories = _.chain(series).map('data').map('rows').flatten().sortBy('key').map('key').uniq().value();

  series.map(serie => {
    if (!serie.data)
      return serie; // no data

    let rows = serie.data.rows;
    let serieCategories = _.chain(rows).flatten().sortBy('key').map('key').uniq().value();
    let missingKeys = _.difference(globalCategories, serieCategories);

    if (missingKeys.length) {
      // some missing rows
      let rowsKeys = _.map(rows, 'key');
      missingKeys.forEach(missingKey => rows.push({key: missingKey, value: 0}));
    }

    serie.data.rows = _.sortBy(rows, 'key');
  });

  return series;
}

export function topCountriesTransformResponse(res, translate) {
  return res.map((res) => {
    res.data.key = translate(`countryCodes.${res.data.key}`);
    res.data.tooltipName = res.data.key;
    return res;
  });
}

export function thickColumnTransformResponse(series, seriesName, transformRow) {
  return series.map((serie) => {
    serie.csvFilename = `${seriesName}.csv`;
    serie.data.rows = _.sortBy(serie.data.rows, (row) => { return parseInt(row.key, 10); });
    if (transformRow)
      serie.data.rows = _.map(serie.data.rows, (row) => transformRow(row));
    return serie;
  });
}

export function thickColumnDecorateSerie(serie, maxPointWidth = 25, showInLegend = false) {
  _.merge(serie, {
    customBorderRadius: 5,
    maxPointWidth: maxPointWidth,
    showInLegend: showInLegend
  });
}


/** WEBPACK FOOTER **
 ** ./src/common/util/chart-util.js
 **/